// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T18:32:00.061Z
// Property: Hilltops (ID: 6767906449162890)
// Collections: 36 amenities, 11 floorplans (live), 40 photos, 5 POIs, 6 reviews, 4 virtual tours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449162890",
  "property_external_id": "4400055",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/hilltops-conroe-tx/0qtvn00",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "hilltops",
  "property_name": "Hilltops",
  "property_website_url": "https://www.hilltopsapts.com/",
  "property_domain": null,
  "property_address": "2200 N Loop 336 W",
  "property_full_address": "2200 N Loop 336 W",
  "property_address_1": "2200 N Loop 336 W",
  "property_address_2": null,
  "property_address_city": "Conroe",
  "property_address_state": "TX",
  "property_address_zip_full": "77304-3635",
  "property_address_zip": "77304",
  "property_address_country": "US",
  "property_address_county": "Montgomery County",
  "property_neighborhood_address": "Outlying Montgomery County",
  "property_address_latitude": "30.3309582",
  "property_address_longitude": "-95.4926097",
  "property_email": "hilltops@alapts.com",
  "property_phone": "(936) 756-1188",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your perfect home at Hilltops in Conroe, Texas! Choose from our spacious one and two-bedroom floor plans, and enjoy outstanding amenities like a refreshing pool, playground, and tennis court. Experience vintage charm with modern conveniences—controlled access, on-site maintenance, and more. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "Welcome to Hilltops, a charming apartment community nestled in the heart of Conroe, Texas. Our vintage building exudes character while providing modern comforts, making it the ideal place to call home. With a variety of thoughtfully designed floor plans, we offer spacious one and two-bedroom apartments to suit your lifestyle.\n\nAt Hilltops, your comfort is our priority. Dive into relaxation at our refreshing pool, or enjoy a fun-filled day at our playground and tennis court. Our meticulously maintained courtyard features a grill and picnic area, perfect for hosting gatherings with friends or unwinding in the sun. With on-site laundry facilities, maintenance, and a dedicated property manager, we ensure that your living experience is hassle-free and enjoyable.\n\nSafety and convenience are key at Hilltops, featuring controlled access for peace of mind. The walk-up design not only adds to our building's unique charm but also allows for easy access to your home. \n\nExperience the vibrant community of Conroe, with local attractions just minutes away. Our friendly community invites you to embrace a lifestyle of comfort and convenience. \n\nDon’t wait any longer—find your new home today at Hilltops! Browse our availability or schedule a tour to visit our community and discover everything we have to offer. Your ideal living experience awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-b6f7-72be-9333-126231a01f97.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool and clubhouse at a multifamily property",
    "public_id": "019cfddc-b6f7-72be-9333-126231a01f97",
    "storage_key": "property/6767906449162890/019cfddc-b6f7-72be-9333-126231a01f97.webp",
    "width": 1240,
    "height": 828
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "208",
  "property_year_built": "2017",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.11538461538461",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-ab10-74be-a921-f9765f5b2213.webp",
  "property_primary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfddc-ab10-74be-a921-f9765f5b2213",
    "storage_key": "property/6767906449162890/019cfddc-ab10-74be-a921-f9765f5b2213.webp",
    "width": 325,
    "height": 147
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-ab10-74be-a921-f9765f5b2213.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfddc-ab10-74be-a921-f9765f5b2213",
    "storage_key": "property/6767906449162890/019cfddc-ab10-74be-a921-f9765f5b2213.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "724 - 1239",
  "property_sqft_min": "724",
  "property_sqft_max": "1239",
  "property_price_range": "1163.16 - 1672",
  "property_price_min": "1163.16",
  "property_price_max": "1672",
  "property_available_units": 6,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Hilltops in Conroe, Texas! Explore our diverse floor plans, including one and two-bedroom apartments. See what's around our community and uncover local favorites and nearby points of interest that make Hilltops the perfect place to call home. Your new adventure awaits!",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "Located 40 miles north of Houston, Conroe combines small-town atmosphere with contemporary living along the shores of Lake Conroe. The city offers year-round water recreation, including boating and fishing on its namesake lake. Downtown Conroe features the historic Crighton Theatre, built in 1935, which continues to host performances throughout the year. Outdoor enthusiasts appreciate W. Goodrich Jones State Forest, home to walking trails and native wildlife, including the protected red-cockaded woodpecker. Current rental trends show average prices ranging from $1,158 for one-bedroom units to $2,257 for four-bedroom homes, with most properties experiencing slight decreases in rates over the past year.\n\t\t\t\t\tHousing options span from apartment communities to single-family homes across various neighborhoods, including the historic downtown area, lakefront properties near Lake Conroe, and the expanding west side.\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\tLearn more about living in Conroe",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Hilltops in Conroe, Texas, where comfort meets convenience! Choose from spacious one and two-bedroom floor plans while enjoying our fantastic amenities like a relaxing pool, tennis court, and picnic area. Explore our vintage building, controlled access, and dedicated on-site management today—your perfect home awaits!",
  "property_applynow_blurb": "Discover your perfect getaway at Hilltops in Conroe, Texas! Choose from spacious one and two-bedroom floor plans, and enjoy exceptional amenities like a refreshing pool, playground, and tennis court. Experience vintage charm with modern conveniences. Find your new home and lease online today!",
  "property_contactus_blurb": "Discover your perfect home at Hilltops in Conroe, Texas! Choose from spacious one and two-bedroom floor plans designed for comfort and style. Explore all options to find your ideal living space. Have questions? Contact our leasing team today to experience the vibrant community of Hilltops!",
  "property_faqs_blurb": "Discover your ideal home at Hilltops in Conroe, Texas, featuring spacious one and two-bedroom floor plans tailored for your lifestyle. Have questions? Browse our FAQs page to find answers about our vibrant community and apartment living. Your perfect space awaits—explore Hilltops today!",
  "property_floorplans_blurb": "Discover your ideal living space at Hilltops in Conroe, Texas! Choose from our thoughtfully designed one and two-bedroom floor plans to fit your lifestyle. Explore our options and envision your new home. Ready to elevate your living experience? Browse our available apartment homes today and find your perfect floor plan!",
  "property_gallery_blurb": "Discover the charm of Hilltops in Conroe, Texas! Our vintage building features one and two-bedroom floor plans, a refreshing pool, playground, and tennis court. Enjoy on-site maintenance and a welcoming community. Picture yourself living here—explore our photo gallery today and envision your new home among beautiful amenities!",
  "property_interactivemap_blurb": "Discover your ideal living space at Hilltops in Conroe, Texas! Choose from spacious one and two-bedroom floor plans with fabulous amenities, including a pool, playground, and tennis court. Explore our vintage building with walk-up access. Use our interactive community map to find your perfect apartment today!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "At Hilltops in Conroe, Texas, we offer a variety of spacious floor plans, including one and two-bedroom apartments designed for comfort. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy all the exceptional amenities together! Explore our versatile options and make memories!",
  "property_residentaccess_blurb": "Welcome to Hilltops in Conroe, Texas! Explore our inviting one and two-bedroom floor plans designed for comfort and convenience. Access your resident portal to easily pay rent, schedule maintenance, and stay connected with our community. Log in now to make the most of your living experience!",
  "property_reviews_blurb": null,
  "property_created_at": "1752257799596",
  "property_scheduletour_blurb": "Discover your ideal home at Hilltops in Conroe, Texas! Choose from our spacious one and two-bedroom floor plans, designed for your comfort. Ready to experience our vibrant community? Schedule a tour today and see what our residents have to say about living at Hilltops! Your perfect apartment awaits!",
  "property_thankyou_blurb": "Thank you for your interest in Hilltops, the premier apartment community in Conroe, Texas! Explore our versatile floor plans, including inviting one and two-bedroom options. A team member will reach out to you shortly to assist with your unique needs. Your new home awaits at Hilltops!",
  "property_virtualtours_blurb": "Discover your ideal living space at Hilltops in Conroe, Texas! Explore our thoughtfully designed one and two-bedroom floor plans. Experience the charm and comfort of our community by taking a virtual tour today. Don’t miss your chance to find your perfect apartment for rent—start your journey now!",
  "property_copyright": "2025 All Rights Reserved. Hilltops",
  "property_seo_title_home": "Hilltops | Apartments in Conroe, Texas",
  "property_seo_description_home": "Discover your ideal living space at Hilltops in Conroe, Texas! Choose from our spacious one and two bedroom floor plans designed for comfort and convenience. Enjoy exceptional amenities like a refreshing pool, playground, and tennis court, all within a vintage building featuring controlled access and on-site maintenance. Experience the perfect blend of community and relaxation in our inviting courtyard, with grilling and picnic areas to gather with friends. Find your new home today at Hilltops – where comfort meets community!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Conroe, Texas",
  "property_seo_description_floorplans": "Discover your ideal living space at Hilltops in Conroe, Texas! Explore a variety of thoughtfully designed floor plans, featuring spacious one-bedroom and two-bedroom apartments. Whether you’re seeking cozy comfort or room to grow, we have the perfect layout for you. Browse our available apartment homes today and find the floor plan that suits your lifestyle!",
  "property_seo_title_amenities": "Amenities | Conroe, Texas Apartments for Rent",
  "property_seo_description_amenities": "Discover Hilltops Apartment Community in Conroe, Texas! Explore our diverse floor plans, including spacious one and two-bedroom options, and enjoy top-notch amenities like a refreshing pool, playground, and tennis court. With controlled access, on-site maintenance, and a vintage building charm, you’ll love calling Hilltops home. Don’t miss the picnic area and courtyard—perfect for relaxation! Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Conroe, Texas",
  "property_seo_description_gallery": "\"Explore the stunning photo gallery of Hilltops, a charming apartment community in Conroe, Texas, offering spacious one and two-bedroom floor plans. Enjoy top-notch amenities like a refreshing pool, playground, and vintage charm with controlled access and onsite maintenance. Picture yourself living here—discover your perfect home with beautiful courtyards, picnic areas, tennis courts, and more!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Hilltops Apartments",
  "property_seo_description_virtualtours": "Discover your new home at Hilltops in Conroe, Texas! Browse our diverse floor plans, featuring spacious one-bedroom and two-bedroom apartments designed for your comfort. Take a virtual tour of our beautiful community and see why Hilltops is the perfect place to live. Don’t wait—explore your future home today!",
  "property_seo_title_interactivemap": "Interactive Map | Hilltops Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Hilltops in Conroe, Texas! Explore our spacious one and two-bedroom floor plans, each designed with your comfort in mind. Enjoy a range of amenities including a refreshing pool, children's playground, and cozy picnic area. Experience the charm of our vintage building with controlled access, on-site maintenance, and dedicated property management. Utilize our interactive community map to effortlessly search available apartments, view pricing, and find your next home sweet home at Hilltops today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Conroe, Texas",
  "property_seo_description_neighborhood": "Discover the vibrant community at Hilltops in Conroe, Texas! Explore our stunning one and two-bedroom floor plans while diving into the local neighborhood. See what's around our community and uncover exciting local favorites and nearby points of interest. Start your journey with us today!",
  "property_seo_title_contact": "Contact Us | Hilltops",
  "property_seo_description_contact": "Discover your perfect home at Hilltops in Conroe, Texas! Explore our spacious one and two-bedroom floor plans designed for comfort and style. Have questions? Contact our leasing team today for personalized assistance and to learn more about our vibrant community!",
  "property_seo_title_faqs": "FAQs | Apartments in Conroe, Texas",
  "property_seo_description_faqs": "Discover everything you need to know about Hilltops, your ideal apartment community in Conroe, Texas! Explore our diverse floor plans, featuring spacious one and two-bedroom apartments, and enjoy top-notch amenities like a refreshing pool, playground, tennis court, and picnic area. With controlled access, on-site maintenance, and a dedicated property manager, your comfort is our priority. Have questions? Browse our FAQs page for all the answers about our vintage walk-up building and community offerings!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Conroe, Texas",
  "property_seo_description_reviews": "\"Discover why residents love calling Hilltops in Conroe, Texas, home! Explore our vibrant community with one and two-bedroom floor plans, stunning amenities like a pool, tennis court, and picnic area, along with superb on-site management and maintenance. Learn about the unique charm of our vintage building and controlled access for peace of mind. See what our residents have to say about living at Hilltops and find your perfect home today!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Conroe, Texas",
  "property_seo_description_applynow": "Discover your perfect sanctuary at Hilltops in Conroe, Texas! Our charming vintage building offers a range of thoughtfully designed floor plans, including one and two-bedroom apartments. Enjoy exceptional amenities like a refreshing pool, tennis court, and picnic area, along with on-site maintenance and management for your convenience. Explore our welcoming community with a playground and cozy courtyard. Ready to elevate your living experience? Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Hilltops",
  "property_seo_description_residentaccess": "\"Access your Hilltops resident portal in Conroe, TX! Log in now to easily pay rent, schedule maintenance, and manage your apartment services effortlessly. Your comfort is just a click away!\"",
  "property_seo_title_referafriend": "Refer A Friend | Hilltops",
  "property_seo_description_referafriend": "\"Great friends make great neighbors at Hilltops in Conroe, Texas! Refer a friend to our vibrant apartment community today and enjoy exclusive rewards. Discover the perfect living experience where connections thrive. Start referring now!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Hilltops",
  "property_seo_description_scheduletour": "\"Discover your perfect home at Hilltops in Conroe, Texas! Enjoy stunning views and modern amenities. Schedule a tour of our vibrant community today and experience the lifestyle you've been dreaming of!\"",
  "property_seo_title_privacy": "Privacy Policy | Hilltops",
  "property_seo_description_privacy": "Discover how Hilltops in Conroe, Texas, protects your privacy. Our privacy policy outlines the measures we take to safeguard your personal information. Trust us to keep your data secure and transparent. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Hilltops",
  "property_seo_description_accessibility": "Discover Hilltops in Conroe, Texas, where we prioritize digital inclusion for all residents. Our Accessibility Statement reflects our commitment to creating an inclusive community. Explore how we ensure that everyone can enjoy our amenities and services. Join us in making a difference—learn more today!",
  "property_seo_title_sitemap": "Sitemap | Hilltops",
  "property_seo_description_sitemap": "\"Explore the Hilltops apartment community in Conroe, Texas! Discover our sitemap to effortlessly navigate through our available amenities, floor plans, and local attractions. Your ideal living space awaits—view our sitemap now!\"",
  "property_seo_title_thankyou": "Thank You | Hilltops",
  "property_seo_description_thankyou": "Thank you for reaching out to Hilltops in Conroe, Texas! We appreciate your interest in our charming apartment community. A member of our dedicated team will be in touch shortly to assist you. Discover your new home today!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1784584424940",
  "amenities": [
    {
      "id": "ec_41a451cfbfdb27d867bc3d41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c21c8b52fdbf7068e37209f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8aa8047eb28a57779d68e167",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "2 Inch Faux Wood Blinds",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bed90a212144ae07ebb62e66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Cabinetry & Brushed Nickel Finishes",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5755d48ac70bfaa33871ff8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "Car Wash w/ Vacuum",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_507f65f1b6003fa962b89aa9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Fully Equipped Kitchens with Built-In Microwave",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31227477d7324aac90f1ef31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Cappuccino Bar",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58a044a2928d130d645843e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4bdeedba3a5eb1878b023c20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000623",
      "title": "Covered Parking",
      "amount": "0.0000",
      "description": "Covered Parking Available",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04bb9e7573882b182b1270e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000624",
      "title": "Crown Molding",
      "amount": "0.0000",
      "description": "Decorative Crown Molding",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09c886f14dca3c7ae9b30f48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9fbc42a6b2017c66b12f8780",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000634",
      "title": "Fire Pit",
      "amount": "0.0000",
      "description": "Fire Pit & Outdoor Gas Kitchen Area",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e41229afa7aef6adfa3fc3b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67b256f2e7185de18b067e76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Garages Available",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b9c3b502e8a1ee8d154e874",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Black and Stainless-Steel Appliances*",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_342f887d344d57da4785262d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000653",
      "title": "Lake",
      "amount": "0.0000",
      "description": "Scenic Lakes w/ Walking Paths",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e610eadd627b7f1f57d0c0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_780f773fedd48dfcf989ab0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Balconies & Patios with Storage*",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eafe1017959c23df13962c3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Pool with Designer Lounge Furniture",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_196c7cbb887a2fb6f6c5f188",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a28f50ea285c898c9aeba756",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000689",
      "title": "Sunroom",
      "amount": "0.0000",
      "description": "Sunrooms*",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e4be1a2db9fe5275aa111d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Dramatic 9' or Vaulted Ceilings",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6813f01b178be9dbe4b370b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000697",
      "title": "Tubs",
      "amount": "0.0000",
      "description": "Oval Garden Tubs",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f75aa1cbb6f1d824c01c5fc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Washer and Dryer Connections*",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43a72254131b947bdcfeb149",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers*",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_133606f3129306d4758a3ecd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000001279",
      "title": "BBQ",
      "amount": "0.0000",
      "description": "Barbecue & Picnic Areas",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2fd45de916b3727c71ea60f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000002380",
      "title": "Billiards Room",
      "amount": "0.0000",
      "description": "Clubroom w/ Billiards Table",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3bc0f0c58818dbccff494fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000003",
      "title": "First Floor Unit",
      "amount": "25.0000",
      "description": "First Floor",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5befdd08a694f3a3411ea2ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000005",
      "title": "Third Floor",
      "amount": "-25.0000",
      "description": "Third Floor",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a574e98956fdc34af606fb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000050",
      "title": "Wood View_Merged",
      "amount": "0.0000",
      "description": "Wood View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_882673ec34696c3d1d06a8fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000122",
      "title": "View",
      "amount": "0.0000",
      "description": "View",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02f39c04a00813fea27d795f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000151",
      "title": "Handicap Accessible",
      "amount": "-30.0000",
      "description": "Handicap Accessible",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc697b1be4a11d29b16c655c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000257",
      "title": "Plank Flooring",
      "amount": "0.0000",
      "description": "Plank Flooring",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c001d5f9b9e53a700541db42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "P000000290",
      "title": "Vaulted Ceilings",
      "amount": "0.0000",
      "description": "Vaulted Ceilings",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02dcb423720c1893e86fa1f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "S100000288",
      "title": "Lake view",
      "amount": "20.0000",
      "description": "Lake view",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e4ec4ac59caeb9d1792782b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "realpage",
      "external_id": "S100000294",
      "title": "Pool view",
      "amount": "25.0000",
      "description": "Pool view",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_8fc67f97ad175e2ae3d53b2d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddb-f8c4-768f-b6f2-cff5a6ced169.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with water heater above and laundry supplies on shelf.",
        "public_id": "019cfddb-f8c4-768f-b6f2-cff5a6ced169",
        "storage_key": "property/6767906449162890/019cfddb-f8c4-768f-b6f2-cff5a6ced169.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer with a water heater and storage shelf for laundry essentials.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with water heater above and laundry supplies on shelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Y6g7sIINOHaVtf3DYZG83JBj7Vd5DsNsFZZYoCllt1g/102/image.jpg"
    },
    {
      "id": "ec_9cedaffb3ac00d3b6fe867a6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddb-fb54-71ff-a525-63bbf906d029.webp",
      "image_media": {
        "alt_text": "Living room with brown leather sofa, coffee table, TV, and sliding glass doors opening to a patio.",
        "public_id": "019cfddb-fb54-71ff-a525-63bbf906d029",
        "storage_key": "property/6767906449162890/019cfddb-fb54-71ff-a525-63bbf906d029.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable brown leather sofa, a stylish coffee table, and a wall-mounted TV, with access to an outdoor patio.",
      "link": "false",
      "alt_text": "Living room with brown leather sofa, coffee table, TV, and sliding glass doors opening to a patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ao9Z73Qhs_f4pEs5ke3lw8aKzrmT7PgOwMAbY070hZA/106/image.jpg"
    },
    {
      "id": "ec_17a7ff524c52e6096bbea0b8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddb-f7e0-71e8-a7ce-ad082389ab3b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel sink, dark wood cabinets, and black appliances.",
        "public_id": "019cfddb-f7e0-71e8-a7ce-ad082389ab3b",
        "storage_key": "property/6767906449162890/019cfddb-f7e0-71e8-a7ce-ad082389ab3b.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "View of a spacious kitchen featuring granite countertops, a double sink with a modern faucet, and ample cabinet space, opening into a living area.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel sink, dark wood cabinets, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/frkM4RtZY8AwVEbToQGjJVpVf6UoBRjSCKVb2cjtZms/105/image.jpg"
    },
    {
      "id": "ec_43b873e85bfd6b1b7a75d428",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddb-f894-7505-95b4-3b453571e79a.webp",
      "image_media": {
        "alt_text": "Spacious communal living area with a large sectional sofa, armchairs, coffee table, and entertainment center.",
        "public_id": "019cfddb-f894-7505-95b4-3b453571e79a",
        "storage_key": "property/6767906449162890/019cfddb-f894-7505-95b4-3b453571e79a.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed communal living spaces, featuring comfortable seating, a large television, and elegant decor.",
      "link": "false",
      "alt_text": "Spacious communal living area with a large sectional sofa, armchairs, coffee table, and entertainment center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/PRODDWqyeCoH9TAkFGj7B4i-33RjEtCmBRBZk1LDzG8/106/image.jpg"
    },
    {
      "id": "ec_df1774bf6b008efa9432abbe",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019d20a8-bb30-7475-8664-d927d7e5e7e5.webp",
      "image_media": {
        "alt_text": "Conference room with a large table and chairs, multiple screens on the wall.",
        "public_id": "019d20a8-bb30-7475-8664-d927d7e5e7e5",
        "storage_key": "property/6767906449162890/019d20a8-bb30-7475-8664-d927d7e5e7e5.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Host your next meeting in our state-of-the-art conference room, equipped with multiple screens and comfortable seating for productive sessions.",
      "link": "false",
      "alt_text": "Conference room with a large table and chairs, multiple screens on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/s9_L1lPwcSxUHx9pfFOFBoTULroOop_b_pJ9-6R_V_s/105/image.jpg"
    },
    {
      "id": "ec_b6814c1b4bc9fe3efec384ac",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-056f-76ba-b66b-8d1a2f90e8fc.webp",
      "image_media": {
        "alt_text": "Cozy living room with a leather sofa, armchair, coffee table, and balcony view.",
        "public_id": "019cfddc-056f-76ba-b66b-8d1a2f90e8fc",
        "storage_key": "property/6767906449162890/019cfddc-056f-76ba-b66b-8d1a2f90e8fc.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in style in this beautifully appointed living room, featuring a plush leather sofa, comfortable armchair, and access to a private balcony.",
      "link": "false",
      "alt_text": "Cozy living room with a leather sofa, armchair, coffee table, and balcony view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3idWtSb340UTzSH6SfVgKbu2nnNWAsAvBOVzpgK6vJE/102/image.jpg"
    },
    {
      "id": "ec_c82348b7ce5897a307b0790c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-0620-711b-b20d-0c235b25a221.webp",
      "image_media": {
        "alt_text": "Dining area with a round black table, four chairs, and place settings.",
        "public_id": "019cfddc-0620-711b-b20d-0c235b25a221",
        "storage_key": "property/6767906449162890/019cfddc-0620-711b-b20d-0c235b25a221.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy meals in this elegant dining area, featuring a round table set for four, perfect for hosting guests or enjoying family dinners.",
      "link": "false",
      "alt_text": "Dining area with a round black table, four chairs, and place settings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/fRIVPb8BDEqOjNUayHwbfFDHYkJWLHgbYd69wd6wRbc/119/image.jpg"
    },
    {
      "id": "ec_9ffae398d7f9477ef037f165",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-08cf-75bb-ac37-50b32e182ff2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, granite countertops, and hardwood floors.",
        "public_id": "019cfddc-08cf-75bb-ac37-50b32e182ff2",
        "storage_key": "property/6767906449162890/019cfddc-08cf-75bb-ac37-50b32e182ff2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen featuring dark wood cabinetry, sleek granite countertops, and modern stainless steel appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, granite countertops, and hardwood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/psgvz9D0T91WPvJKP57vVWlltd832oEbgjcAzFOYoB8/102/image.jpg"
    },
    {
      "id": "ec_14ea4ebbc670041a2c16efcd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-125a-712d-961d-819a0013d0c0.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, navy and white pillows, and gray curtains.",
        "public_id": "019cfddc-125a-712d-961d-819a0013d0c0",
        "storage_key": "property/6767906449162890/019cfddc-125a-712d-961d-819a0013d0c0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with comfortable bedding, decorative pillows, and elegant gray curtains that complement the room's decor.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, navy and white pillows, and gray curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rqqdYYW6QMCJ1-zKoAbk1Ji2LBN1iewYjj133Yq-izg/119/image.jpg"
    },
    {
      "id": "ec_a9c5eb2e5d7bc0fdb9e94bc5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-1252-7769-97c3-70314911aee4.webp",
      "image_media": {
        "alt_text": "Empty closet with shelves and hangers.",
        "public_id": "019cfddc-1252-7769-97c3-70314911aee4",
        "storage_key": "property/6767906449162890/019cfddc-1252-7769-97c3-70314911aee4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space, perfect for organizing your wardrobe.",
      "link": "false",
      "alt_text": "Empty closet with shelves and hangers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HqrjiR6zKBd9wgQZHHL-K7weQD-JmqWhYbLEDSDI82A/102/image.jpg"
    },
    {
      "id": "ec_68387ed771b1b3a54c84beab",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-126a-74e9-b2c6-83d3e3e209b6.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, shower curtain, toilet, and vanity with granite countertop.",
        "public_id": "019cfddc-126a-74e9-b2c6-83d3e3e209b6",
        "storage_key": "property/6767906449162890/019cfddc-126a-74e9-b2c6-83d3e3e209b6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax and unwind in your spacious bathroom, featuring a bathtub, convenient shower, and a well-appointed vanity with ample counter space.",
      "link": "false",
      "alt_text": "Bathroom with bathtub, shower curtain, toilet, and vanity with granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/F0Ent4zkw6HrMHseAzHDoMnJGoWlrh950J1wqA8BmE8/119/image.jpg"
    },
    {
      "id": "ec_d21bf34f67fe414dd5cb290f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-146b-720f-91f8-a1473c777331.webp",
      "image_media": {
        "alt_text": "Washer and dryer with water heater above",
        "public_id": "019cfddc-146b-720f-91f8-a1473c777331",
        "storage_key": "property/6767906449162890/019cfddc-146b-720f-91f8-a1473c777331.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience, with a water heater located above.",
      "link": "false",
      "alt_text": "Washer and dryer with water heater above",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/JR4RWd3F9cyuBZTFYDY3_NMFu1zMhvDaEqzNRy2BgOw/102/image.jpg"
    },
    {
      "id": "ec_58f6967b347e433792cbdf54",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-1f62-743a-b5b2-e3342afa2bf4.webp",
      "image_media": {
        "alt_text": "Balcony with a table and chairs overlooking a parking lot and apartment buildings.",
        "public_id": "019cfddc-1f62-743a-b5b2-e3342afa2bf4",
        "storage_key": "property/6767906449162890/019cfddc-1f62-743a-b5b2-e3342afa2bf4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, complete with a seating area and scenic views of the community and surrounding nature.",
      "link": "false",
      "alt_text": "Balcony with a table and chairs overlooking a parking lot and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2witntE5eCwwBrtuBXWcIZtLW7N_CWmHkpuWJC-DW4Q/119/image.jpg"
    },
    {
      "id": "ec_e2c4e1ddf59c19ae598a8858",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-2187-742f-8b72-63b4d4998b4a.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019cfddc-2187-742f-8b72-63b4d4998b4a",
        "storage_key": "property/6767906449162890/019cfddc-2187-742f-8b72-63b4d4998b4a.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling resort-style swimming pool, complete with comfortable lounge chairs and lush palm trees.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/YMAmqgVkLYNLfgsdZLS5B1BibKWVe14tuegHKNZJBRI/119/image.jpg"
    },
    {
      "id": "ec_9699ef4f85205ac76e958666",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-22b2-77c5-b815-ceb5b65437d5.webp",
      "image_media": {
        "alt_text": "Spacious lobby with a stone fireplace, plush seating, and elegant decor.",
        "public_id": "019cfddc-22b2-77c5-b815-ceb5b65437d5",
        "storage_key": "property/6767906449162890/019cfddc-22b2-77c5-b815-ceb5b65437d5.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lobby, featuring a cozy fireplace and comfortable seating areas perfect for socializing or quiet reflection.",
      "link": "false",
      "alt_text": "Spacious lobby with a stone fireplace, plush seating, and elegant decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jlU8d703Vc22S59wN74bc02_yBM6LB80wLzRvXhkFIA/119/image.jpg"
    },
    {
      "id": "ec_d0624a622d7aec2c8c75a963",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-2265-712e-a43e-bc663fce824b.webp",
      "image_media": {
        "alt_text": "Living room with a leather sofa, coffee table, and balcony access.",
        "public_id": "019cfddc-2265-712e-a43e-bc663fce824b",
        "storage_key": "property/6767906449162890/019cfddc-2265-712e-a43e-bc663fce824b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush leather sofa, stylish coffee table, and access to a private balcony, perfect for relaxation.",
      "link": "false",
      "alt_text": "Living room with a leather sofa, coffee table, and balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DcCSpGkZ9uO5e9xjHswMge21CMY_RsOKYonDI5RaImY/106/image.jpg"
    },
    {
      "id": "ec_44ec5b0409f2a33f3da9f7fd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-2d91-7333-a7c0-d50b7d356bf6.webp",
      "image_media": {
        "alt_text": "Aerial view of a sparkling swimming pool with lounge chairs and umbrellas, surrounded by lush landscaping and a building.",
        "public_id": "019cfddc-2d91-7333-a7c0-d50b7d356bf6",
        "storage_key": "property/6767906449162890/019cfddc-2d91-7333-a7c0-d50b7d356bf6.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning swimming pool, complete with comfortable lounge seating and shaded areas. Enjoy the resort-style amenities at your doorstep.",
      "link": "false",
      "alt_text": "Aerial view of a sparkling swimming pool with lounge chairs and umbrellas, surrounded by lush landscaping and a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/IM5KVB2J6OwqGsTTubuSPNBgZnn3CCipeq9EVlYht0g/102/image.jpg"
    },
    {
      "id": "ec_f54af91bb222e0316f4501b3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019d4f32-b585-753b-b31f-ebc5d8e698ee.webp",
      "image_media": {
        "alt_text": "Dining room with round table, four leather chairs, and wall art.",
        "public_id": "019d4f32-b585-753b-b31f-ebc5d8e698ee",
        "storage_key": "property/6767906449162890/019d4f32-b585-753b-b31f-ebc5d8e698ee.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a round table set for four, surrounded by stylish leather chairs. Modern decor includes a striking abstract painting and decorative mirrors.",
      "link": "false",
      "alt_text": "Dining room with round table, four leather chairs, and wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jMeD91KTebpTjEcDFfbAw0aIOvnTA40MrB_rpZsqdHA/104/image.jpg"
    },
    {
      "id": "ec_8ac3e152abbcde571694bdde",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-31ce-75a3-80a7-c90fb168fded.webp",
      "image_media": {
        "alt_text": "Car wash and air station at multifamily property.",
        "public_id": "019cfddc-31ce-75a3-80a7-c90fb168fded",
        "storage_key": "property/6767906449162890/019cfddc-31ce-75a3-80a7-c90fb168fded.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Convenient car wash and air station for residents, featuring a high-pressure hose and tire inflation services. Parking is enforced for overnight restrictions.",
      "link": "false",
      "alt_text": "Car wash and air station at multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hGD24ft7MIvFn1UG_aMFWAFBWDbqcpnkl58LmcERJqE/102/image.jpg"
    },
    {
      "id": "ec_1e7ab1fee2390f7d1905a93a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-301b-7652-a57f-910dec3c120e.webp",
      "image_media": {
        "alt_text": "Outdoor patio seating with blue couches and yellow pillows overlooking a swimming pool and apartment buildings.",
        "public_id": "019cfddc-301b-7652-a57f-910dec3c120e",
        "storage_key": "property/6767906449162890/019cfddc-301b-7652-a57f-910dec3c120e.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Relax and unwind in our resort-style pool area, complete with comfortable lounge seating and an outdoor patio, perfect for enjoying the sunshine.",
      "link": "false",
      "alt_text": "Outdoor patio seating with blue couches and yellow pillows overlooking a swimming pool and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6eEBddiYWhgIYKrgNA8A7o_vdtjjYWgqreP_W-0DnnU/118/image.jpg"
    },
    {
      "id": "ec_3bd407166cea00cd79c67bb4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-3f5d-7674-a44f-743eb0837ec3.webp",
      "image_media": {
        "alt_text": "Balcony with table and chairs overlooking parking lot and trees.",
        "public_id": "019cfddc-3f5d-7674-a44f-743eb0837ec3",
        "storage_key": "property/6767906449162890/019cfddc-3f5d-7674-a44f-743eb0837ec3.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, complete with outdoor seating and scenic views of the community.",
      "link": "false",
      "alt_text": "Balcony with table and chairs overlooking parking lot and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1wEJL8ylN5RXg5Szj1-XghVZIi2D1-rHhSJ6tYSymm4/102/image.jpg"
    },
    {
      "id": "ec_04c3ad5df49f880234df2019",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-3bd8-717e-b77a-8a337bec91f4.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, dresser, and large window.",
        "public_id": "019cfddc-3bd8-717e-b77a-8a337bec91f4",
        "storage_key": "property/6767906449162890/019cfddc-3bd8-717e-b77a-8a337bec91f4.webp",
        "width": 2048,
        "height": 1363
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a comfortable king-size bed, a wooden dresser with a mirror, and a bright window with blinds. Perfect for relaxation and restful nights.",
      "link": "false",
      "alt_text": "Modern bedroom with a king-size bed, dresser, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/pPuPZe0eoIduNaFFpKIMj8AIDQMfvdi8l48tAQU8ow8/113/image.jpg"
    },
    {
      "id": "ec_50b2115a118cff4360498dc6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-3fec-750d-a9f7-3d1261b34d1c.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a pond and fountain.",
        "public_id": "019cfddc-3fec-750d-a9f7-3d1261b34d1c",
        "storage_key": "property/6767906449162890/019cfddc-3fec-750d-a9f7-3d1261b34d1c.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Beautiful apartment buildings with a serene pond and fountain, creating a peaceful community atmosphere.",
      "link": "false",
      "alt_text": "Apartment buildings with a pond and fountain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/nSEwfJqZzVyAbFTzi8uFamx1LmNEfhFipyOlLVyjTkI/119/image.jpg"
    },
    {
      "id": "ec_af1a6acc932cc2e677385c46",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-4146-743a-8e14-e09fbf4024da.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, sink, mirror, and dark cabinets.",
        "public_id": "019cfddc-4146-743a-8e14-e09fbf4024da",
        "storage_key": "property/6767906449162890/019cfddc-4146-743a-8e14-e09fbf4024da.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "View of a clean and modern apartment bathroom featuring a vanity with granite countertops, a spacious sink, a decorative mirror, and ample cabinet storage.",
      "link": "false",
      "alt_text": "Bathroom vanity with granite countertop, sink, mirror, and dark cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/QCnF8yFViqQwBURJwRuVCSA980W6vEE1wUtWd6hxcBg/119/image.jpg"
    },
    {
      "id": "ec_0e944085196449ad02650e17",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019d4f32-de60-732f-9ed7-d0621fae785f.webp",
      "image_media": {
        "alt_text": "Exterior aerial view of apartment buildings surrounded by trees.",
        "public_id": "019d4f32-de60-732f-9ed7-d0621fae785f",
        "storage_key": "property/6767906449162890/019d4f32-de60-732f-9ed7-d0621fae785f.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Aerial view of apartment buildings nestled within a lush, green landscape, offering a serene living environment.",
      "link": "false",
      "alt_text": "Exterior aerial view of apartment buildings surrounded by trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Cxu6cQFWDm9n0VdtUqHAHZ6CDdD9LGkOOUmwFnWZmIo/102/image.jpg"
    },
    {
      "id": "ec_6295697b709ffad633a0a959",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019d4f32-cc9e-7208-8e97-5fe97f6f4758.webp",
      "image_media": {
        "alt_text": "View of a modern apartment kitchen and dining area with bar stools, a dining table, and decorative wall art.",
        "public_id": "019d4f32-cc9e-7208-8e97-5fe97f6f4758",
        "storage_key": "property/6767906449162890/019d4f32-cc9e-7208-8e97-5fe97f6f4758.webp",
        "width": 2048,
        "height": 341
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring a modern kitchen and a dedicated dining space, perfect for entertaining.",
      "link": "false",
      "alt_text": "View of a modern apartment kitchen and dining area with bar stools, a dining table, and decorative wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cozLsBDlBI7Ycquoi-3X1Q0XTeZEjJKxDIfbxdDdiwY/102/image.jpg"
    },
    {
      "id": "ec_4cfad16e299636ef2793e0db",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-4e4f-700c-8670-1495a8da0e76.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019cfddc-4e4f-700c-8670-1495a8da0e76",
        "storage_key": "property/6767906449162890/019cfddc-4e4f-700c-8670-1495a8da0e76.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, complete with comfortable lounge chairs and lush landscaping for the perfect oasis.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2s9D1HXG73KAMZn39t3LmZ_yj8RcHGZJpZgZOw6gp4o/119/image.jpg"
    },
    {
      "id": "ec_5ac08036f10680bbc97a8227",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-4f73-779f-8061-c0dcec33d2f3.webp",
      "image_media": {
        "alt_text": "Living room with leather sofa, coffee table, and view into bedroom and kitchen.",
        "public_id": "019cfddc-4f73-779f-8061-c0dcec33d2f3",
        "storage_key": "property/6767906449162890/019cfddc-4f73-779f-8061-c0dcec33d2f3.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable leather sofa, a unique wooden coffee table, and an open view to the kitchen and a serene bedroom.",
      "link": "false",
      "alt_text": "Living room with leather sofa, coffee table, and view into bedroom and kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6bfsfX90EtGznRUSoGPbUdpg7EN18qTrBrUscXGr48I/111/image.jpg"
    },
    {
      "id": "ec_4fd5da8effebec2787fa59dc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-583d-7398-84eb-a0ed42bdb85d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinets.",
        "public_id": "019cfddc-583d-7398-84eb-a0ed42bdb85d",
        "storage_key": "property/6767906449162890/019cfddc-583d-7398-84eb-a0ed42bdb85d.webp",
        "width": 1604,
        "height": 1267
      },
      "title": "Apartment",
      "description": "Experience sleek urban living with this fully equipped kitchen, featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/db-go7l1RWwKpxdnaQIA01ktdh7cPR0GvnLbvQq6N38/119/image.jpg"
    },
    {
      "id": "ec_55aafd605364eea24037f2c1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-5b58-729b-9fcc-19ca238601d1.webp",
      "image_media": {
        "alt_text": "Living room with a brown leather sofa, wooden coffee table, and sliding glass doors leading to a balcony.",
        "public_id": "019cfddc-5b58-729b-9fcc-19ca238601d1",
        "storage_key": "property/6767906449162890/019cfddc-5b58-729b-9fcc-19ca238601d1.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a plush brown leather sofa, a unique wooden coffee table, and elegant decor. Enjoy direct access to your private balcony for outdoor relaxation.",
      "link": "false",
      "alt_text": "Living room with a brown leather sofa, wooden coffee table, and sliding glass doors leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/nkC-vTZISuUdcKkZqTT0Sjq4Rw0Yqp_j3rZu4B5Iupg/111/image.jpg"
    },
    {
      "id": "ec_f297ad645746e1745961e9bb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-5cad-74bf-b922-aac54a15ed48.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, armchair, and a walk-in closet.",
        "public_id": "019cfddc-5cad-74bf-b922-aac54a15ed48",
        "storage_key": "property/6767906449162890/019cfddc-5cad-74bf-b922-aac54a15ed48.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Apartment",
      "description": "Relax in this inviting bedroom, featuring a comfortable queen-size bed, plush armchair, and convenient walk-in closet.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-size bed, armchair, and a walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/U-VL_MGslRUYeHfSLzz6yDfaVOlP0kz-3ddfFx5KErk/119/image.jpg"
    },
    {
      "id": "ec_8ce73694d740e26d907bc819",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-5a4c-70e4-bdb1-2e146fa070db.webp",
      "image_media": {
        "alt_text": "Dining area with chairs and table, washer, and dryer.",
        "public_id": "019cfddc-5a4c-70e4-bdb1-2e146fa070db",
        "storage_key": "property/6767906449162890/019cfddc-5a4c-70e4-bdb1-2e146fa070db.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round table with upholstered chairs, adjacent to a laundry closet with washer and dryer.",
      "link": "false",
      "alt_text": "Dining area with chairs and table, washer, and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/A0sxM9ZNVqjYLOKGi3BahMqa8gTxH99lN0tok2OA_ss/111/image.jpg"
    },
    {
      "id": "ec_00b1771a491d559c8121287d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-64b5-70a9-a5f8-0d66b9bf4ac1.webp",
      "image_media": {
        "alt_text": "Dining room with a round table set for four, leather chairs, and abstract art.",
        "public_id": "019cfddc-64b5-70a9-a5f8-0d66b9bf4ac1",
        "storage_key": "property/6767906449162890/019cfddc-64b5-70a9-a5f8-0d66b9bf4ac1.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in this beautifully appointed dining room, featuring a round table, comfortable seating, and tasteful decor.",
      "link": "false",
      "alt_text": "Dining room with a round table set for four, leather chairs, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/fGGqSbdDSpZ8pgP46QuevJ6fpmNVEeObe2xyoatmOro/119/image.jpg"
    },
    {
      "id": "ec_290d074ef9d2999d0096fa3d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-68b1-7581-85c5-8dd72fd300ff.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019cfddc-68b1-7581-85c5-8dd72fd300ff",
        "storage_key": "property/6767906449162890/019cfddc-68b1-7581-85c5-8dd72fd300ff.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, stainless steel dishwasher, and ample cabinet space, opening to a spacious living area.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and dark wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/i1XAXGxJcs3e0fBrr328jXrWSs2ZY1eYbKzpIOIoYo0/111/image.jpg"
    },
    {
      "id": "ec_c8d9f19c9628c1f778741731",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-6922-73ec-ae8d-28faf67bf96b.webp",
      "image_media": {
        "alt_text": "Spacious bathroom with a bathtub, shower, vanity, and toilet.",
        "public_id": "019cfddc-6922-73ec-ae8d-28faf67bf96b",
        "storage_key": "property/6767906449162890/019cfddc-6922-73ec-ae8d-28faf67bf96b.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Apartment",
      "description": "Step into comfort and convenience in this beautifully appointed bathroom, featuring a soaking tub, modern vanity, and ample space.",
      "link": "false",
      "alt_text": "Spacious bathroom with a bathtub, shower, vanity, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/i9qn41aCAnw_rcB6Y9lTHmlb6cXrFv85cK4D6oi3S84/119/image.jpg"
    },
    {
      "id": "ec_e3977ce16241dca3434a130b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-6901-7050-a9e6-a141b0bef4f9.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, mirror, and sink. Toilet with decorative plants and artwork on the wall.",
        "public_id": "019cfddc-6901-7050-a9e6-a141b0bef4f9",
        "storage_key": "property/6767906449162890/019cfddc-6901-7050-a9e6-a141b0bef4f9.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Apartment",
      "description": "Experience modern comfort in this stylish bathroom featuring a spacious vanity, elegant mirror, and a relaxing ambiance. Perfect for unwinding.",
      "link": "false",
      "alt_text": "Bathroom vanity with granite countertop, mirror, and sink. Toilet with decorative plants and artwork on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/PAj6x4cszXw2awhxI_S96Bwc_CPQa-H3wMHQmlHqBpA/111/image.jpg"
    },
    {
      "id": "ec_2547b96181688eda9cb3b266",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-73ea-76cb-9307-a496ee9bb165.webp",
      "image_media": {
        "alt_text": "Walk-in closet with open door leading to a bathroom with toilet and vanity.",
        "public_id": "019cfddc-73ea-76cb-9307-a496ee9bb165",
        "storage_key": "property/6767906449162890/019cfddc-73ea-76cb-9307-a496ee9bb165.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space, with a glimpse into a well-appointed bathroom.",
      "link": "false",
      "alt_text": "Walk-in closet with open door leading to a bathroom with toilet and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/0Zkucqlhf-E9adK1Yz264jpRGNwEjVU6fWiacKTtH1k/119/image.jpg"
    },
    {
      "id": "ec_787d14ae7094c742202cdfe5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-7668-705d-bd16-d29d227b93fb.webp",
      "image_media": {
        "alt_text": "Dog park with play equipment and apartment buildings in the background.",
        "public_id": "019cfddc-7668-705d-bd16-d29d227b93fb",
        "storage_key": "property/6767906449162890/019cfddc-7668-705d-bd16-d29d227b93fb.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, complete with agility equipment for your furry friends to play and exercise. Plenty of green space for them to run around.",
      "link": "false",
      "alt_text": "Dog park with play equipment and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/IHDfVu1CZWPq3lEUwPtxyJXInASuydld2tVdNRRbXBY/111/image.jpg"
    },
    {
      "id": "ec_f6420441a7824391ad9eaee1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-7549-762f-b62d-717d20b122bd.webp",
      "image_media": {
        "alt_text": "Conference room with a large table, chairs, and multiple TVs.",
        "public_id": "019cfddc-7549-762f-b62d-717d20b122bd",
        "storage_key": "property/6767906449162890/019cfddc-7549-762f-b62d-717d20b122bd.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Community",
      "description": "Modern conference room with a large wooden table, comfortable chairs, and a wall mounted TV array. Perfect for business meetings and resident events.",
      "link": "false",
      "alt_text": "Conference room with a large table, chairs, and multiple TVs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/FZt-d7j8upm3l_uJN4z-76vBqmAwNvrqTKW2TnYOgQw/119/image.jpg"
    },
    {
      "id": "ec_4270a671e22c53e0731f8c89",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-772a-7105-9e57-ef40eea5b5b5.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, stationary bikes, and weightlifting equipment in a modern apartment complex gym.",
        "public_id": "019cfddc-772a-7105-9e57-ef40eea5b5b5",
        "storage_key": "property/6767906449162890/019cfddc-772a-7105-9e57-ef40eea5b5b5.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, fully equipped with cardio machines and free weights for a great workout.",
      "link": "false",
      "alt_text": "Treadmills, ellipticals, stationary bikes, and weightlifting equipment in a modern apartment complex gym.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/w9_GGlsKm6kqyPD1c8Iy4yG8EuvjEbZy2VKmtxsXJgA/111/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_cd07645f7db154ef68fe0b1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "apartments",
      "poi_name": "Cryar Intermediate",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_63a100621211d6297fb2de05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "apartments",
      "poi_name": "Peet Junior High School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_35508d81bd928019fb6069a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "apartments",
      "poi_name": "Conroe High School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_019e7a2b65923b7f9ed99ae5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "apartments",
      "poi_name": "Conroe Christian School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_eaae0943d23767bef5bae546",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "apartments",
      "poi_name": "Area Vocational School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [],
  "reviews": [
    {
      "id": "ec_4fb5dbc0fbb7ac24861c5922",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "rating": "5",
      "name": "false",
      "text": "This is by far the best apartment I have ever lived in. I was very skeptical about apartment living and  when I sold my house two years ago I told my son we would only live here for a year until we decided where we wanted to buy another home. It has been such a great experience for us that we decided to stay and we are now past our second year. The management and staff are awesome and have become true friends. The are always very warm  and helpful and are even willing to consider suggestions for improvements to our community. I want to say a special thanks to Brooke and Kim for treating me with such kindness and for always taking the time out of their busy day to say hello and chat for a minute when I come in for coffee. I tell everyone I know what a great place Hilltops Apartment’s is to live!",
      "date": "false",
      "title": "Best apartment"
    },
    {
      "id": "ec_bf897517c2d8d7f806e78114",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "rating": "5",
      "name": "false",
      "text": "The apartment was ready for us to move in. Our last apartment we were there for nine years. We are seniors and debated on buying or renting. Since I'm disable we settled on renting. Ashley showed us the apartments and we fell in love with them. It's very quiet, the kitchen is huge. Any questions we have , Ashley, Brooke and Amanda are all very helpful. They make you feel so comfortable. We looked at several places and this is the best. We love it here. The maintenance guys are Awesome as well. Just had to have a couple of things done when moving in. They came right away got the job done. If your looking for a place to call home, this is it. It doesn't get any better than this. We love it and we are here to stay.",
      "date": "false",
      "title": "Awesome place to live"
    },
    {
      "id": "ec_da0a6e0451a5fbd1677f6ec1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "rating": "5",
      "name": "false",
      "text": "Love these apartments, they are clean and everyone is so nice and welcoming. ",
      "date": "false",
      "title": "Great apartments "
    },
    {
      "id": "ec_25de1d4051354dfa370dd986",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "rating": "5",
      "name": "false",
      "text": "I toured the community and the staff is top notch. Everyone so friendly and helpful!!",
      "date": "false",
      "title": "Great staff"
    },
    {
      "id": "ec_230579c65107ccf6fcafdddb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "rating": "5",
      "name": "false",
      "text": "Ashland and the entire staff were friendly, professional, and easy to work with. The property is super clean and well groomed. We are pleased we choose Hilltops as our residence.   The Nixon’s ",
      "date": "false",
      "title": "First Class Customer Service + more "
    },
    {
      "id": "ec_07be4663aef68eb9fd8b5ba9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "rating": "5",
      "name": "false",
      "text": "I absolutely love this community! From the very beginning—before I even moved to the area—I had the pleasure of working with Fonda, the leasing agent. She was welcoming, knowledgeable, and truly the driving force behind my decision to make this community my home.\n\nFonda went above and beyond from day one. She graciously gave my daughter, who already lived in the area, a guided tour while I joined via FaceTime. She helped me find the perfect unit, coordinated my move-in timeline, and made the entire application process smooth and stress-free.\n\nWe communicated for weeks before my move, and when I finally met her in person, it felt like greeting family. Fonda has continued to be an incredible support—always attentive, professional, and genuinely caring about residents’ satisfaction. She’s been an essential part of my positive experience here.\n\nI also love how the management team organizes community events, how friendly and helpful everyone in the office is, and the small perks—like complimentary Starbucks coffee every morning! The property is beautifully maintained, and it’s clear that pride and care go into every detail.\n\nThis community feels like home, thanks in large part to Fonda and the wonderful team behind it.",
      "date": "false",
      "title": "A true gem"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_f45c97ef7393783582af4d44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddb-fb54-71ff-a525-63bbf906d029.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with brown leather sofa, coffee table, TV, and sliding glass doors opening to a patio.",
        "public_id": "019cfddb-fb54-71ff-a525-63bbf906d029",
        "storage_key": "property/6767906449162890/019cfddb-fb54-71ff-a525-63bbf906d029.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "1BR, 1BA - 724SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mzryoACuEfz"
    },
    {
      "id": "ec_0e42b3e46566982a3c63ab7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-9eb6-77e3-b2c6-c486679cccf5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Island kitchen with dark cabinets and sink, opens to living area.",
        "public_id": "019cfddc-9eb6-77e3-b2c6-c486679cccf5",
        "storage_key": "property/6767906449162890/019cfddc-9eb6-77e3-b2c6-c486679cccf5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,239SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ogu5GZMh9Dy"
    },
    {
      "id": "ec_e9eab73161ff2ab18076395a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddb-f894-7505-95b4-3b453571e79a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious communal living area with a large sectional sofa, armchairs, coffee table, and entertainment center.",
        "public_id": "019cfddb-f894-7505-95b4-3b453571e79a",
        "storage_key": "property/6767906449162890/019cfddb-f894-7505-95b4-3b453571e79a.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UHhfeLb4WgA"
    },
    {
      "id": "ec_06f0231c79fa5a6a8eee6b9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162890",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162890/019cfddc-0333-727e-96c6-0d4126d2b363.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Conference room with a large table, chairs, and multiple TVs on the wall.",
        "public_id": "019cfddc-0333-727e-96c6-0d4126d2b363",
        "storage_key": "property/6767906449162890/019cfddc-0333-727e-96c6-0d4126d2b363.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Conference Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YUxJmcyBY3E"
    }
  ],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_text_field",
      "type": "STRING",
      "value": " GTM-P3TMZM2K"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Avenue"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "Test new field addition"
    }
  ],
  "custom_text_field": " GTM-P3TMZM2K",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Avenue",
  "custom_broker_license_number": "Test new field addition"
};

export const generatedAt = '2026-10-05T18:32:00.061Z';
